var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:_vm.classes,attrs:{"data-color":_vm.color},on:{"mousedown":function($event){return _vm.doRipple($event)}}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"ripple",style:(_vm.rippleStyle())})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea39d57c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Btn.vue
// module id = null
// module chunks = 